let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bFCl7")).then(() => parcelRequire('kUiRE'));